export default __webpack_public_path__ + "static/media/scan.c60f404f.svg";